import { createContext } from "react";
const CurrentUserContext = createContext(null);
const CurrentUserProvider = CurrentUserContext.Provider;
const CurrentUserConsumer = CurrentUserContext.Consumer;
export { CurrentUserContext, CurrentUserProvider, CurrentUserConsumer };
